import { PublicClientApplication } from '@azure/msal-browser'
import { CredentialResponse, TokenResponse } from '@react-oauth/google'

interface UserData {
	username: string
    firstName: string
    lastName: string
    company?: string
}
interface ApiResponse {
	status: 'OK' | 'error'
	data: UserData
}
export const microsoftLoginSignupHandler = async (clientId: string) => {
	const config = {
		auth: {
			clientId,
		},
	}
	const msalInstance = new PublicClientApplication(config)
	const loginRequest = {
		scopes: ['user.read'],
	}
	const respFromMicrosoftApi = await msalInstance.loginPopup(loginRequest)
	const token = respFromMicrosoftApi.idToken
	const resp = await fetch('/users/microsoft_login', {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify({ token }),
	})
	const result = await resp.json() as ApiResponse
	return { result, respFromMicrosoftApi }
}

export const googleLoginSignupHandler = async (response: CredentialResponse | TokenResponse) => {
	const body: {
		googleCredential?: string
		googleToken?: string
	} = {}
	if ('credential' in response) {
		body.googleCredential = response.credential
	} else if ('access_token' in response) {
		body.googleToken = response.access_token
	}
	const resp = await fetch('/users/google_login', {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify({ ...body }),
	})
	const result = await resp.json() as ApiResponse
	return result
}
